// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".member-card{height:204px;width:323.5px;font-size:10px;margin-top:80px;border-radius:12px;border:1px solid #000;overflow-y:hidden;font-weight:600}.member-card-header{height:35px;width:100%}.member-card-content{height:calc(100% - 35px);width:100%}.member-card-domain{font-weight:700;color:#666565;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);
// Exports
module.exports = exports;
